import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problems } from './components/Problems';
import { SystemIntro } from './components/SystemIntro';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Bonuses } from './components/Bonuses';
import { Scarcity } from './components/Scarcity';
import { PricingPack } from './components/PricingPack';
import { Reviews } from './components/Reviews';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Comparison } from './components/Comparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
const META_PIXEL_ID = '1418882266928316';
export function App() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const fbq: MetaPixel = (...args: unknown[]) => {
      fbq.queue?.push(args);
    };
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <main className="w-full bg-black font-sans text-white antialiased" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsBar data-id="element-2" />
      <TestimonialStrip data-id="element-3" />
      <Problems data-id="element-4" />
      <SystemIntro data-id="element-5" />
      <Modules data-id="element-6" />
      <ModuleIncludes data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Scarcity data-id="element-9" />
      <PricingPack data-id="element-10" />
      <Reviews data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <Comparison data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
    </main>;
}